import styled from 'styled-components';

export const Wrapper = styled.div`
	background-color: #ffffff;
	width: 100%;
	padding: 30px;
`;

export const TextContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	align-items: center;
	margin-top: 40px;
`;

export const NoteContainer = styled.div`
	background-color: #f2f9f0;
	font-weight: 500;
	font-size: 17px;
	padding: 10px;
`;

export const SubNoteContainer = styled.div`
	font-size: 16px;
`;
